module.exports = __webpack_public_path__ + "static/media/FT-CHAVA-VR.78f448e9.png";